import { render, staticRenderFns } from "./ReviewProduct.vue?vue&type=template&id=5076772d&scoped=true"
import script from "./ReviewProduct.vue?vue&type=script&lang=js"
export * from "./ReviewProduct.vue?vue&type=script&lang=js"
import style0 from "./ReviewProduct.vue?vue&type=style&index=0&id=5076772d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5076772d",
  null
  
)

export default component.exports